import {i18n} from '@yourcoach/i18n';

import type {DeclineOption, MembershipDeclineReason} from './types';

import {not} from '../../../../utils/conditionalUtils';

export const getReasonTranslations = (): Record<
  MembershipDeclineReason,
  string
> => ({
  group_full: i18n.t('shared:group_full'),
  group_in_progress: i18n.t('shared:group_in_progress'),
  initial_intro_call_required: i18n.t('shared:prerequisite_initial_intro_call'),
  other: i18n.t('shared:other'),
});

export const getReasonOptions = (
  isIndividualProgram: boolean,
): DeclineOption[] => {
  const reasonTranslations = getReasonTranslations();

  const isGroupProgram = not(isIndividualProgram);

  return [
    isGroupProgram
      ? {id: 'group_in_progress', label: reasonTranslations.group_in_progress}
      : null,
    isGroupProgram
      ? {id: 'group_full', label: reasonTranslations.group_full}
      : null,
    {
      id: 'initial_intro_call_required',
      label: reasonTranslations.initial_intro_call_required,
    },
    {id: 'other', label: reasonTranslations.other},
  ].filter(Boolean) as DeclineOption[];
};
